import logo from '@assets/logo.png';
import EventSeatRoundedIcon from '@mui/icons-material/EventSeatRounded';
import LockRoundedIcon from '@mui/icons-material/LockRounded';
import PublicOffRoundedIcon from '@mui/icons-material/PublicOffRounded';
import TabletMacRoundedIcon from '@mui/icons-material/TabletMacRounded';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

const items = [
  {
    icon: <PublicOffRoundedIcon sx={{ color: 'text.secondary' }} />,
    title: 'Runs on your network',
    description: 'Licensing stays inside the site. No connection to the cloud service is required.',
  },
  {
    icon: <LockRoundedIcon sx={{ color: 'text.secondary' }} />,
    title: 'Signed license files',
    description: 'Seats and features come from encrypted files issued by CDMVision, bound to this server.',
  },
  {
    icon: <EventSeatRoundedIcon sx={{ color: 'text.secondary' }} />,
    title: 'Floating seats',
    description: 'Seats are shared, not assigned. An idle client releases its seat for the next one.',
  },
  {
    icon: <TabletMacRoundedIcon sx={{ color: 'text.secondary' }} />,
    title: 'SuPAR and Composer',
    description: 'The apps connect with nothing but a different server address.',
  },
];

const Content = () => {
  return (
    <Stack sx={{ flexDirection: 'column', alignSelf: 'center', gap: 4, maxWidth: 450 }}>
      <Box sx={{ display: { xs: 'none', md: 'flex' }, flexDirection: 'column' }}>
        <img src={logo} width={150} alt='SuPAR' />
        <Typography variant='caption' sx={productNameStyles}>Private License Server</Typography>
      </Box>

      {items.map((item) => (
        <Stack key={item.title} direction='row' sx={{ gap: 2 }}>
          {item.icon}
          <div>
            <Typography gutterBottom>{item.title}</Typography>
            <Typography variant='body2' sx={{ color: 'text.secondary', fontWeight: '200' }}>
              {item.description}
            </Typography>
          </div>
        </Stack>
      ))}
    </Stack>
  );
};

const productNameStyles = {
  color: 'text.secondary',
  letterSpacing: '0.08em',
  textTransform: 'uppercase',
  fontSize: '0.65rem',
  marginTop: '6px',
  marginLeft: '2px',
};

export default Content;
